/**
 * Formats `User.reliabilityScore` (computed on read as 0.0 - 1.0) as a whole
 * percentage. Returns null only when the field is missing. A user with no
 * scored jobs is `1.0`, which formats as 100%.
 */
export const formatReliabilityScore = (
  reliabilityScore: number | null | undefined,
): string | null => {
  if (reliabilityScore == null || isNaN(reliabilityScore)) return null;
  return `${Math.round(reliabilityScore * 100)}%`;
};
